import React from 'react';
import { PaymentMethod, CreditCard, PaymentMethodType, PaymentOnTerms, generatedTypesNew } from '@css-xp/graphtypes';
import { PaymentErrorLozenge } from '../../../copyable-text';
import { defaultTo, get } from 'lodash';

export const PaymentMethodSelectDetailsLine = ({
  paymentMethod,
  creditDetails,
}: {
  paymentMethod?: PaymentMethod | null;
  creditDetails?: {
    totalCreditLimit: number;
    availableCreditLimit: number;
  };
}) => {
  if (!paymentMethod) {
    return (
      <span>
        <em>No payment method</em>
      </span>
    );
  }

  switch (paymentMethod?.type as any) {
    case PaymentMethodType.CARD: {
      const creditCard = paymentMethod as CreditCard;
      return (
        <span>
          Credit card: **** {creditCard?.card?.last4Numbers} ({creditCard?.card?.brand?.toUpperCase()}), exp -{' '}
          {creditCard?.card?.expirationMonth}/{creditCard?.card?.expirationYear}
          {paymentMethod.paymentIssue && <PaymentErrorLozenge />}
        </span>
      );
    }
    case PaymentMethodType.DEFERRED: {
      const paymentOnTerms = paymentMethod as PaymentOnTerms;
      return creditDetails ? (
        <span>{`Net-${paymentOnTerms.terms?.invoiceDueDays}, Credit limit available: ${defaultTo(
          get(creditDetails, 'availableCreditLimit'),
          0
        )} Total credit limit: ${defaultTo(get(creditDetails, 'totalCreditLimit'), 0)}.`}</span>
      ) : (
        <span>Payment on terms: due in {paymentOnTerms.terms?.invoiceDueDays} days</span>
      );
    }
    case generatedTypesNew.PaymentMethodTypeV2.PAYPAL: {
      return <span>Paypal: {(paymentMethod as any)?.payPal?.email}</span>;
    }
    default:
      return (
        <div>
          <em>Unknown payment method</em>
        </div>
      );
  }
};
